import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux'
// import isEqual from 'react-fast-compare'
import moment from 'moment';
import { withLocalize } from 'react-localize-redux'
import Layout from './../../Layout'
import Loader from './../../Layout/Loader'
import Typography from '@mui/material/Typography'
import EmptyState from './../../Components/common/EmptyState'
import {
  checkPrivileges,
  convertSpeedUnits,
  getDateTimeFormat,
  PaginationConfig,
  setAttributeFormatForDlogs,
} from '../../Helpers'
import { RemoteReactTable } from '../../Components/common/ReactBaseTable'
import axios from 'axios'
import { exportFile } from '../../Components/common/ExportExcel'
import ConfirmDialoag from '../../Components/common/ConfirmDialoag';
import instance from '../../axios';
// import MultiAxisChart from '../../Components/Message/MultiAxisGraph';
import DynamicLineGraph from '../../Components/Message/ReCharts';
import Notifications from 'react-notification-system-redux';


Object.defineProperty(Array.prototype, 'chunk', {
  value: function (chunkSize) {
    var R = []
    for (var i = 0; i < length; i += chunkSize)
      R.push(slice(i, i + chunkSize))
    return R
  }
})


const Messages = (props) => {
  const dispatch=useDispatch()

  const [state, setState] = useState({
    from: '',
    to: '',
    selectedDate: '',
    detail: false,
    loading: false,
    tableLoading: false,
    validatedForm: false,
    device: {},
    device1: {},
    currentPage: 1,
    callSent: false,
    pagination: {
      ...PaginationConfig,
      pageSize: 20,
    },
    data: [],
    attributes: [],
    isExport: false,
    query: '',
    dateDialogOpen: false,
  });
  const [graphData, setGraphData] = useState(null)

  useEffect(() => {
    setState(prevState => ({
      ...prevState,
      validatedForm: !!(state.device && state.device.value)
    }));
  }, [state.device]);

  // useEffect(() => {
  //   const timezone = props.ServerSetting?.attributes?.timezone || props.logInUser?.attributes?.timezone || 'Asia/Dubai';
  //   moment.tz.setDefault(timezone);
  // }, [props.ServerSetting, props.logInUser]);

  if (!checkPrivileges('position')) {
    props.history.push('/');
    return null;
  }
  const [selectedDeviceAttributes, setSelectedDeviceAttributes] = useState([])
  const [deviceAttributes, setDeviceAttributes] = useState([]);
  const handleSaveDeviceAttributes = (items) => {
    setDeviceAttributes(items)
  }
  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      validatedGraphForm: deviceAttributes?.length > 0
    }));

  }, [deviceAttributes]);

  const selectDevice = (e) => {
    setSelectedDeviceAttributes([])
    setDeviceAttributes([])
    setState(prevState => ({
      ...prevState,
      device: { ...e },
      validatedForm: !!(e && e.value)
    }));
  };

  const changeDetail = (name, e) => {
    setState(prevState => ({ ...prevState, detail: e.target.checked }));
  };

  const selectDate = (e, date) => {
    const adjustedEndDate = date.endDate.clone().set({ hour: 23, minute: 59, second: 59, millisecond: 999 });

    let timezone = 'Asia/Dubai';
    if (
      props.ServerSetting &&
      props.ServerSetting.attributes &&
      props.ServerSetting.attributes.timezone
    ) {
      timezone = props.ServerSetting.attributes.timezone;
    }
    if (
      props.logInUser &&
      props.logInUser.attributes &&
      props.logInUser.attributes.timezone
    ) {
      timezone = props.logInUser.attributes.timezone;
    }
    moment.tz.setDefault(timezone);

    var formattedDate = {
      from: moment(date.startDate?.format('YYYY-MM-DD HH:mm')).toISOString(),
      // to: adjustedEndDate.toISOString(),
      to: moment(date.endDate?.format('YYYY-MM-DD HH:mm')).toISOString()
    }
    const daysDifference = adjustedEndDate.diff(date.startDate, 'days');
    if (daysDifference > 2) {
      setState((prevState) => ({
        ...prevState,
        dateDialogOpen: true
      }))

    } else {
      setState((prevState) => ({
        ...prevState,
        dateDialogOpen: false
      }))
    }
    let timeFormat = getDateTimeFormat();
    setState((prevState) => ({
      ...prevState,
      selectedDate:
        moment(formattedDate.from)?.format(timeFormat) +
        ' - ' +
        moment(formattedDate.to)?.format(timeFormat),
      ...formattedDate,
      validatedForm: prevState.device && prevState.device.value ? true : false,
    }));
  };
  const graphFormDateSelect = (e, date) => {
    const adjustedEndDate = date.endDate.clone().set({ hour: 23, minute: 59, second: 59, millisecond: 999 });

    let timezone = 'Asia/Dubai';
    if (
      props.ServerSetting &&
      props.ServerSetting.attributes &&
      props.ServerSetting.attributes.timezone
    ) {
      timezone = props.ServerSetting.attributes.timezone;
    }
    if (
      props.logInUser &&
      props.logInUser.attributes &&
      props.logInUser.attributes.timezone
    ) {
      timezone = props.logInUser.attributes.timezone;
    }
    moment.tz.setDefault(timezone);

    let formattedDate = {
      graphfrom: moment(date.startDate?.format('YYYY-MM-DD HH:mm')).toISOString(),
      graphto: moment(date.endDate?.format('YYYY-MM-DD HH:mm')).toISOString()
    }
    const daysDifference = adjustedEndDate.diff(date.startDate, 'days');
    if (daysDifference > 1) {
      setState((prevState) => ({
        ...prevState,
        graphFormDialog: true
      }))

    } else {
      setState((prevState) => ({
        ...prevState,
        graphFormDialog: false
      }))
    }
    let timeFormat = getDateTimeFormat();
    setState((prevState) => ({
      ...prevState,
      selectedDateGraph:
        moment(formattedDate.graphfrom)?.format(timeFormat) +
        ' - ' +
        moment(formattedDate.graphto)?.format(timeFormat),
      ...formattedDate,
    }));
  };
  const onDelete = () => {
    setState((prevState) => ({
      ...prevState,
      dateDialogOpen: false,
      selectedDate: "",
      from: "",
      to: ""
    }))
  }
  const onDeleteGraph = () => {
    setState((prevState) => ({
      ...prevState,
      graphFormDialog: false,
      selectedDateGraph: "",
    }))
  }
  useEffect(() => {
    const deviceId = state.device?.id;
    if (!deviceId || !Object.keys(props.deviceRelatedData || {}).length) return;
    const position = props.deviceRelatedData[deviceId];
    if (position?.attributes) {
      setSelectedDeviceAttributes(position);
    } else {
      setSelectedDeviceAttributes([]);
    }
  }, [state.device?.id, props.deviceRelatedData]);


  useEffect(() => {

  }, [deviceAttributes])

  const getAttributes = async (device) => {
    return await axios.get(`/api/attributes/computed?deviceId=${device}&all=true`)
  }

  const createMessagesReport = (reset, type) => {
    if (type === 'excel') {
      let Dform = {
        from: state.from,
        to: state.to,
        device: state.device.id,
        detail: state.detail,
      };
      exportFile('Dlogs', Dform,{dispatch});
    } else {
      setState((prevState) => ({
        ...prevState,
        loading: true,
        callSent: false,
      }));
      getAttributes(state.device.value).then(({ status, data }) => {
        if (status === 200) {
          const attributes = [];
          if (data?.data && data?.data?.length) {

            data?.data.forEach((d) => {
              if (d.category > 0) {
                attributes.push(d.attribute);
              }
            });
          }
          attributes.push('totalDistance', 'hours', 'stopTime', 'idlTime', 'parking');
          setState((prevState) => ({
            ...prevState,
            attributes,
          }));
          let query = '?';
          if (state.validatedForm) {
            if (state.device && state.device.value) {
              query += '&deviceId=' + state.device.value;
            }
            if (state.to) {
              query += '&to=' + state.to;
            }
            if (state.from) {
              query += '&from=' + state.from;
            }
            query += '&detail=' + state.detail;
            getMoreItems(query);
          }
        }
      });
    }
  };

  const getMoreItems = (query) => {
    setState(prevState => ({ ...prevState, query, callSent: true, tableLoading: false, loading: false }))
  }
  // new work 
  const [selectedForm, setSelectedForm] = useState("dlogsForm")
  const handleSelectForm = (form) => {
    setState(prevState => ({
      ...prevState,
      device: {},
      selectedDateGraph: "",
      graphfrom: "",
      graphto: "",
      callSent: false,
    }));
    setSelectedDeviceAttributes([])
    setGraphData(null)
    setDeviceAttributes([])
    setSelectedForm(form)
  }
const transformToGraphData = (rawData) => {
  if (!Array.isArray(rawData) || rawData.length === 0) return {};

  const graphData = {};

  rawData.forEach((item) => {
    const time = new Date(item.time).getTime();
    if (!time) return;

    Object.keys(item).forEach((key) => {
      if (key === 'time') return;

      if (!graphData[key]) {
        graphData[key] = [];
      }

      let v;
      if (key === 'ignition') {
        v = item[key];
      } else {
        v = setAttributeFormatForDlogs ? setAttributeFormatForDlogs(key, item[key]) : item[key];
        v = typeof v === 'string' ? parseFloat(v) : Number(v);
        if (isNaN(v)) return;
      }

      graphData[key].push({ x: time, y: v });
    });
  });

  return graphData;
};



  const handleSubmitGraphForm = async () => {
    const data = {
      from: state.graphfrom,
      to: state.graphto,
      deviceId: state.device.id,
      attributes: deviceAttributes,
    };
    const queryParams = new URLSearchParams({
      deviceId: data.deviceId,
      from: data.from,
      to: data.to,
    });

    data.attributes.forEach(attr => {
      queryParams.append('axis', attr);
    });

    const url = `/api/positions/graph?${queryParams.toString()}`;
    try {
      const response = await instance.get(url);
      if (response && Array.isArray(response) && response?.length === 0) {
        setGraphData(null);
        dispatch(
          Notifications.error({
            message: props.translate('No data found'),
            autoDismiss: 10
          })
        )

      } else if (response) {
        const graphData = transformToGraphData(response)
        setGraphData(graphData)
      }
    } catch (error) {
      console.error('Error fetching graph data:', error);
    }
  };




  const { query } = state;
  const serverTimeZoneName = props.ServerSetting?.attributes?.timezone || props.logInUser?.attributes?.timezone || 'Asia/Dubai';
  const handleSaveData = (data) => {
    setState((prevState) => ({
      ...prevState,
      data
    }))
  }
const getDynamicAttributeColumns = (data, translate) => {
  const uniqueKeys = new Set();
  data.forEach(row => {
    const attr = row.attributes || {};
    Object.keys(attr).forEach(key => {
      uniqueKeys.add(key);
    });
  });

  return Array.from(uniqueKeys).map(key => ({
    Header: translate(key) || key,
    accessor: row => {
      const attr = row.attributes || {};
      return attr[key] ?? '-';
    },
    id: `attr_${key}`,
    headerClassName: 'text-center',
    width: 75,
    Cell: ({ value }) => value,
  }));
};

const useColumns = (props, state, serverTimeZoneName) => {
  const baseColumns = React.useMemo(() => [
    {
      Header: props.translate('address'),
      accessor: 'address',
      width: 250
    },
    {
      Header: props.translate('time'),
      accessor: 'fixTime',
      headerClassName: 'text-center',
      width: 150,
      Cell: ({ value }) => {
        let timeFormat = getDateTimeFormat();
        let value1 = moment.tz(value, serverTimeZoneName)?.format(timeFormat);
        return value1;
      },
    },
    {
      Header: props.translate('positionLatitude'),
      accessor: 'latitude',
      headerClassName: 'text-center',
      width: 75
    },
    {
      Header: props.translate('positionLongitude'),
      accessor: 'longitude',
      headerClassName: 'text-center',
      width: 75
    },
    {
      Header: props.translate('sensorsTranslation.speed'),
      accessor: 'speed',
      headerClassName: 'text-center',
      width: 55,
      Cell: ({ value }) => {
        let value1 = convertSpeedUnits(value, 'kn', 'kmh');
        return `${value1} km/h`;
      },
    },
    ...(!state.detail ? [
      {
        Header: props.translate('parameters'),
        accessor: row => {
          const attr = row.attributes;
          const arr = Object.keys(attr).filter(r => r !== 'unknown' && !state.attributes.includes(r));
          return arr.map(key => key + "=" + attr[key]).join(', ');
        },
        headerClassName: 'text-left',
        width: 400
      },
      {
        Header: props.translate('sensorValue'),
        accessor: row => {
          const attr = row.attributes;
          return state.attributes.map(key => key + "=" + (attr[key] !== undefined ? attr[key] : "")).join(', ');
        },
        headerClassName: 'text-left',
        width: 400
      },
    ] : []),
    {
      Header: props.translate('course'),
      accessor: 'course',
      headerClassName: 'text-center',
      width: 55
    },
    {
      Header: props.translate('altitude'),
      accessor: 'altitude',
      headerClassName: 'text-center',
      width: 60
    },
    {
      Header: props.translate('serverTime'),
      accessor: 'serverTime',
      headerClassName: 'text-left',
      width: 150,
      Cell: ({ value }) => {
        let timeFormat = getDateTimeFormat();
        let value1 = moment.tz(value, serverTimeZoneName)?.format(timeFormat);
        return value1;
      },
    }
  ], [props.translate, state.attributes, state.detail, serverTimeZoneName]);

  const dynamicAttrColumns = React.useMemo(() => {
    return getDynamicAttributeColumns(state.data, props.translate);
  }, [state.data, props.translate]);
  return React.useMemo(() => {
    return state.detail ? [...baseColumns, ...dynamicAttrColumns] : baseColumns;
  }, [state.detail, baseColumns, dynamicAttrColumns]);
}
 const columns = useColumns(props, state, serverTimeZoneName);




  if (checkPrivileges('position')) {
    return (
      <div>
        <Layout
          {...props}
          classFromChildren='has-padding'
          selectDate={selectDate}
          selectDevice={selectDevice}
          selectedDevice={state.device}
          validatedForm={state.validatedForm}
          createMessagesReport={createMessagesReport}
          changeDetail={changeDetail}
          handleSubmitGraphForm={handleSubmitGraphForm}
          selectedForm={selectedForm}
          selectedDeviceAttributes={selectedDeviceAttributes}
          handleSelectForm={handleSelectForm}
          deviceAttributes={deviceAttributes}
          setDeviceAttributes={handleSaveDeviceAttributes}
          graphFormDateSelect={graphFormDateSelect}
          selectedDateGraph={state.selectedDateGraph}
          {...state}
        >
          <div className='main-content-page'>
            <div
              style={{
                background: props.themecolors.backgroundColor,
                color: props.themecolors.textColor,
                borderRadius: 6
              }}
            >
              {!state.loading && !state.callSent && selectedForm === "dlogsForm" && (
                <EmptyState
                  text={props.translate('noTrackersSelected')}
                />
              )}
              {selectedForm === "graphForm" &&!state.callSent&&!graphData&& (
                  <EmptyState text={props.translate('noTrackersSelected')} />
                )}

              {!state.loading && selectedForm === "dlogsForm" ? (
                <React.Fragment>
                  <Typography
                    variant='h5'
                    component='h4'
                    style={{
                      margin: 0,
                      color: 'inherit',
                      padding: '15px 20px'
                    }}
                  >
                    {state.device1.label}
                  </Typography>
                  {state.callSent ? <RemoteReactTable
                    serverTimeZone={serverTimeZoneName}
                    data={state.data}
                    handleSaveData={handleSaveData}
                    columns={columns}
                    query={`/api/positions/get${query}`}
                  /> : null}
                </React.Fragment>
              ) : null}
              {/* {selectedForm === "graphForm" &&
                Object.keys(graphData ?? {})?.length > 0 &&
                <MultiAxisChart graphData={graphData} />} */}
  {selectedForm === "graphForm" &&
                Object.keys(graphData ?? {})?.length > 0 &&
                <DynamicLineGraph seriesData={graphData} translate={props.translate}/>}

              {state.loading && <Loader />}

              {state.dateDialogOpen && (
                <ConfirmDialoag
                  onCancel={onDelete}
                  onOk={onDelete}
                  title={props.translate('Alert !')}
                  children={"You can not select more then 3 days"}
                  hideCancel
                />
              )}
              {state.graphFormDialog && (
                <ConfirmDialoag
                  onCancel={onDeleteGraph}
                  onOk={onDeleteGraph}
                  title={props.translate('Alert !')}
                  children={"You can not select more then 1 days"}
                  hideCancel
                />
              )}
            </div>
          </div>
        </Layout>
      </div>
    )
  } else {
    props.history.push('/')
    return null
  }
}

const mapStateToProps = state => ({
  themecolors: state.themeColors,
  logInUser: state.logInUsers,
  allDevices: state.devices3,
  deviceRelatedData: state.deviceRelatedData,
  ServerSetting: state.ServerSetting
})

export default connect(mapStateToProps)((withLocalize(Messages)))
